"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var ExportQuizBtn_1 = __importDefault(require("../../molecules/ExportQuizBtn/ExportQuizBtn"));
var SportsQuizExport_styles_1 = __importDefault(require("./SportsQuizExport.styles"));
var loginState_1 = require("../../../types/loginState");
var react_router_dom_1 = require("react-router-dom");
var SportsQuizExport = function (_a) {
    var loggedIn = _a.loggedIn;
    var _b = react_1.useState(null), suppliers = _b[0], setSuppliers = _b[1];
    var _c = react_1.useState(null), selectedSupplier = _c[0], setSelectedSupplier = _c[1];
    var _d = react_1.useState([]), results = _d[0], setResults = _d[1];
    react_1.useEffect(function () {
        axios_1.default
            .get('/api/exportSupplier')
            .then(function (response) {
            console.log(response.data);
            setSuppliers(response.data);
        })
            .catch(function (error) {
            console.log(error);
        });
    }, []);
    var inputChanged = function (e) {
        var newResults = [];
        var searchKey = e.target.value.toLowerCase();
        if (suppliers && searchKey.length > 2) {
            suppliers.forEach(function (supplier) {
                if (supplier.name && supplier.name.toLowerCase().indexOf(searchKey) >= 0) {
                    newResults.push(supplier);
                }
            });
        }
        else {
            setSelectedSupplier(null);
        }
        setResults(newResults);
    };
    var selectSupplier = function (e) {
        if (e.target && e.target.dataset) {
            setSelectedSupplier({
                name: e.target.dataset.name,
                slug: e.target.dataset.slug,
            });
        }
        setResults([]);
    };
    if (loggedIn !== loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    }
    return (react_1.default.createElement(SportsQuizExport_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("h1", null, "Export maken ")),
            react_1.default.createElement("div", { className: "controls" },
                react_1.default.createElement("input", { onChange: inputChanged, type: "text" }),
                react_1.default.createElement("div", { className: "filter-results" }, results.map(function (result) { return (react_1.default.createElement("button", { className: "filter-result", "data-name": result.name, "data-slug": result.slug, onClick: selectSupplier }, result.name)); })),
                selectedSupplier && (react_1.default.createElement("div", { className: "current-selection" },
                    "Huidige selectie: ",
                    react_1.default.createElement("b", null, selectedSupplier.name))),
                react_1.default.createElement(ExportQuizBtn_1.default, { supplier: selectedSupplier ? selectedSupplier.slug : null })))));
};
exports.default = SportsQuizExport;
